<!-- Template for the Toolbar Header -->
<ng-template #header let-terminal>
  <mat-toolbar elderTheme>
    @let interval = interval$ | async;
    @let currentTime = currentTime$ | async;
    @let activeWorkCenter = activeWorkCenter$ | async;
    @let activeWorkStation = activeWorkStation$ | async;
    @let mode = mode$ | async;
    <div class="flex-grow layout-row place-between-center">
      <div class="layout-row gap-xl">
        <div class="layout-row">
          <button mat-icon-button (click)="goHome(activeWorkCenter)">
            <mat-icon>calendar_view_day</mat-icon>
          </button>

          <div class="layout-col place-center-center">
            <span class="flex text-title-medium" [matTooltip]="terminal?.name">
              {{ terminal?.name | elderTruncate: 24 }}
            </span>
            @if (mode === TerminalMode.LIVE) {
              <small class="flex text-body-small">
                {{ currentTime?.toString() | date: 'medium' }}
              </small>
            } @else {
              @if (interval) {
                <small class="flex text-body-small">{{ interval | isoInterval }}</small>
              }
            }
          </div>
        </div>

        <div class="layout-row gap-sm place-center-center">
          @if (activeWorkCenter) {
            <mat-form-field subscriptSizing="dynamic" elderDense>
              <mat-label>{{ 'context.pool' | translate }}</mat-label>
              <elder-select
                placeholder="{{ 'context.pool' | translate }}"
                [data]="terminal.workCenters"
                [displayProperty]="'name'"
                [value]="activeWorkCenter"
                (entityUpdated)="onWorkCenterActive($event)"
              >
                <p class="noselect" *elderSelectValue="let value">
                  {{ value.number }} {{ value.name }}
                </p>
              </elder-select>
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic" elderDense>
              <mat-label>{{ 'context.machine' | translate }}</mat-label>
              <elder-select
                placeholder="{{ 'context.machine' | translate }}"
                [displayProperty]="'name'"
                [data]="activeWorkCenter.workStations"
                [value]="activeWorkStation"
                (entityUpdated)="onWorkStationActive($event)"
              >
                <p class="noselect" *elderSelectValue="let value">
                  {{ value.number }} {{ value.name }}
                </p>
              </elder-select>
            </mat-form-field>
          }
          @if (activeWorkStation) {
            <app-terminal-ws-configuration [activeWorkStation]="activeWorkStation">
            </app-terminal-ws-configuration>
          }
        </div>
      </div>

      <div class="layout-row place-start-center gap-sm">
        <button
          mat-icon-button
          class="elder-icon-button-md"
          (click)="
            onPreviewProdList(
              $event,
              mode,
              interval,
              currentTime,
              activeWorkCenter.id,
              activeWorkStation?.id
            )
          "
        >
          <mat-icon>assignment</mat-icon>
        </button>

        @let includeUnstartable = includeUnstartable$ | async;
        <div>
          <button
            mat-icon-button
            class="elder-icon-button-md"
            name="includeUnstartable"
            [value]="includeUnstartable"
            (click)="toggleIncludeUnstartable(includeUnstartable)"
          >
            <mat-icon>{{ includeUnstartable ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </div>

        @if (privileged$ | async; as privileged) {
          <button mat-button (click)="switchMode(mode, interval, privileged)">
            <mat-icon>cached</mat-icon>
            {{ mode }}
          </button>
        }
      </div>
    </div>
  </mat-toolbar>
</ng-template>

@if (controlTerminal$ | async; as terminal) {
  <div class="layout-col full">
    <ng-container>
      <!-- Replace the primary Header Toolbar -->
      <ng-container
        *elderShellSlot="'header'"
        [ngTemplateOutlet]="header"
        [ngTemplateOutletContext]="{ $implicit: terminal }"
      ></ng-container>
      <!-- disable static navigation -->
      <ng-template elderShellSlot="static-nav"></ng-template>
    </ng-container>
    <router-outlet class="router-flex"></router-outlet>
  </div>
}
